module.exports = __webpack_public_path__ + "media/images/smart_phone/ttl_aichi-be20d3f7a7070eb20452c4200db4bf7d.png";